@if (isStale()) {
  <app-alert-banner type="info">
    A newer version of FirmFirst is available.
    <dx-button
      banner-actions
      text="Reload"
      type="default"
      stylingMode="contained"
      (onClick)="reload()"
    />
  </app-alert-banner>
}
